import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { EntityAvailableTypeFieldComponent } from './entity-available-type-field.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
  ],
  declarations: [
    EntityAvailableTypeFieldComponent,
  ],
  exports: [
    EntityAvailableTypeFieldComponent,
  ],
})
export class EntityAvailableTypesExportModule {}
